module.exports = __webpack_public_path__ + "img/jicheng (6).f3a1ceb6.png";